export const SUMMARY_INFO_TOOLTIP_CONTENT = [
  {
    text: "نمره نهایی (با نمره منفی):",
    secondaryText: "[(صحیح) − (غلط × نمره‌منفی)] ÷ کل × ۱۰۰",
    description: "(جریمه‌ی پاسخ غلط از امتیاز صحیح کم می‌شود)."
  },
  {
    text: "نمره (بدون نمره منفی):",
    secondaryText: "صحیح÷کل×۱۰۰",
    description: " (فقط پاسخ‌های صحیح نسبت به کل سؤال‌ها سنجیده می‌شود)."
  },
  {
    text: "نرخ پاسخ‌دهی:",
    secondaryText: "(صحیح+غلط)÷کل×۱۰۰",
    description: " (سهم سؤال‌هایی که به آن‌ها پاسخی داده‌اید (درست یا غلط))."
  },
  {
    text: "دقت پاسخ‌دهی",
    secondaryText: "صحیح÷(صحیح+غلط)×۱۰۰",
    description:
      "(کیفیت پاسخ‌های داده‌شده؛ فقط بین سؤال‌های پاسخ‌داده‌شده سنجیده می‌شود)."
  }
];

export const DETAILS_TAB_QUERY_KEY = "details-tab" as const;
